// extracted by mini-css-extract-plugin
module.exports = {"base":"DeterminedAuth_base__359Yj","content":"DeterminedAuth_content__3Wg9M","errorMessage":"DeterminedAuth_errorMessage__36ZoJ","message":"DeterminedAuth_message__3TZiF"};